import type { Template } from "@/types";

export const LA_07_H0_V7: Template[] = [
    {
        id: "la-07-h0v7-01",
        name: "LA 01 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 118, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 118, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 267, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 267, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 57, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 416, y: 269, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 873, y: 57, width: 294, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-02",
        name: "LA 02 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 143, y: 0, width: 390, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 57, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 944, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1093, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 794, y: 269, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 944, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-03",
        name: "LA 03 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 117, y: 37, width: 292, height: 455, rotation: 0, imageRotation: 0 },
            { id: "2", x: 417, y: 37, width: 142, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 269, width: 142, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 851, y: 37, width: 159, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 851, y: 269, width: 159, height: 224, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 37, width: 159, height: 224, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 269, width: 159, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-04",
        name: "LA 04 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 177, y: 37, width: 158, height: 225, rotation: 0, imageRotation: 0 },
            { id: "2", x: 177, y: 270, width: 158, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 37, width: 157, height: 225, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 270, width: 157, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 37, width: 292, height: 456, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 37, width: 142, height: 224, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 269, width: 142, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-05",
        name: "LA 05 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 138, y: 55, width: 265, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 410, y: 55, width: 129, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 410, y: 269, width: 129, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 821, y: 55, width: 276, height: 420, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1105, y: 55, width: 102, height: 135, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1105, y: 198, width: 102, height: 134, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1105, y: 341, width: 102, height: 134, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-06",
        name: "LA 06 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 143, y: 58, width: 260, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 411, y: 268, width: 125, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 411, y: 58, width: 125, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 850, y: 41, width: 160, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 850, y: 273, width: 160, height: 223, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 41, width: 160, height: 224, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 273, width: 160, height: 223, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-07",
        name: "LA 07 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 121, width: 187, height: 290, rotation: 0, imageRotation: 0 },
            { id: "2", x: 195, y: 121, width: 187, height: 290, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 121, width: 186, height: 290, rotation: 0, imageRotation: 0 },
            { id: "4", x: 584, y: 121, width: 186, height: 290, rotation: 0, imageRotation: 0 },
            { id: "5", x: 778, y: 121, width: 186, height: 290, rotation: 0, imageRotation: 0 },
            { id: "6", x: 972, y: 121, width: 186, height: 290, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1166, y: 121, width: 186, height: 290, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-08",
        name: "LA 08 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 42, y: 34, width: 304, height: 460, rotation: 0, imageRotation: 0 },
            { id: "2", x: 354, y: 34, width: 304, height: 460, rotation: 0, imageRotation: 0 },
            { id: "3", x: 665, y: 34, width: 304, height: 460, rotation: 0, imageRotation: 0 },
            { id: "4", x: 976, y: 34, width: 162, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 976, y: 269, width: 162, height: 227, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1146, y: 34, width: 164, height: 227, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1146, y: 269, width: 164, height: 227, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-09",
        name: "LA 09 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 64, y: 0, width: 178, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 270, width: 178, height: 261, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 0, width: 177, height: 262, rotation: 0, imageRotation: 0 },
            { id: "4", x: 250, y: 270, width: 177, height: 261, rotation: 0, imageRotation: 0 },
            { id: "5", x: 435, y: 0, width: 177, height: 262, rotation: 0, imageRotation: 0 },
            { id: "6", x: 435, y: 270, width: 177, height: 261, rotation: 0, imageRotation: 0 },
            { id: "7", x: 812, y: 0, width: 388, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h0v7-10",
        name: "LA 10 - H0V7",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h0_v7_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 185, y: 57, width: 294, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 794, y: 269, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 794, y: 57, width: 142, height: 204, rotation: 0, imageRotation: 0 },
            { id: "4", x: 944, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 944, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 269, width: 141, height: 204, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1093, y: 57, width: 141, height: 204, rotation: 0, imageRotation: 0 }
        ],
    }
];